import {Session} from '@/shared/integrations/better-auth/client'
import {isMobile} from '@cypro/ui/hooks/use-is-mobile'
import {redirect, NavigateFn, NavigateOptions} from '@tanstack/react-router'
import {User} from 'better-auth'

export function getPlaceholderEmail(username: string) {
  return `${username}@cypro.placeholder`
}

interface ImpersonationData {
  adminId: string
  adminName: string
  capUrl: string | null
  orgId: string | null
}

export function parseImpersonationData(data: string | undefined | null) {
  if (!data) return null

  try {
    const parsed = JSON.parse(data) as ImpersonationData
    return parsed
  } catch {
    return null
  }
}

interface InitializeUserSessionPayload {
  auth: {user: User | undefined; session: Session | undefined} | null
  navigate?: NavigateFn
}

export function initializeUserSession({auth, navigate}: InitializeUserSessionPayload) {
  function navigateOrRedirect(opts: NavigateOptions) {
    if (navigate) return navigate(opts)
    throw redirect(opts)
  }

  if (!auth?.user || !auth?.session) {
    if (!location.pathname.startsWith('/auth/login'))
      return navigateOrRedirect({to: '/auth/login', search: {location: location.pathname}})

    return
  }

  if (
    auth.session.account &&
    !auth.session.account.passwordSetupCompletedAt &&
    !location.pathname.startsWith('/auth/password-setup')
  ) {
    return navigateOrRedirect({to: '/auth/password-setup'})
  }

  if (isMobile() && !location.pathname.startsWith('/activity')) return navigateOrRedirect({to: '/activity'})

  if (
    auth.session.account.passwordSetupCompletedAt &&
    !location.pathname.startsWith('/configuration') &&
    !location.pathname.startsWith('/patient-dashboard') &&
    !location.pathname.startsWith('/activity') &&
    !location.pathname.startsWith('/production') &&
    !location.pathname.startsWith('/reports') &&
    !location.pathname.startsWith('/stocks') &&
    !location.pathname.startsWith('/cleanroom')
  ) {
    return navigateOrRedirect({to: '/patient-dashboard/patients'})
  }
}
